<!-- Main Post Modal - Single container for both post, comments, and reactions -->
<app-modal [isOpen]="isModalOpen" (close)="closeModal()" className="max-w-[550px]">
  <div class="relative w-full flex flex-col bg-white rounded-3xl overflow-hidden"
    style="max-height: calc(100vh - 8rem)">

    <!-- Removed-by-admin banner (only ever present for the post's own author) -->
    <div *ngIf="post.isRemovedByAdmin"
      class="flex items-center gap-2 bg-red-50 border-b border-red-200 text-red-700 text-xs font-medium px-5 py-2 flex-shrink-0">
      <svg class="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
      </svg>
      <!-- Admin opened this from the admin panel (preview link) -->
      <span *ngIf="isAdminPreview; else removedOwnerText">Removed by admin — hidden from other users. Only the author can still see it.</span>
      <ng-template #removedOwnerText>
        <span>This content has been removed by admin and is only visible to you.</span>
      </ng-template>
    </div>

    <!-- Header - Always visible with user info -->
    <div class="flex items-center justify-between px-5 py-4 bg-gray-100 flex-shrink-0 relative z-10"
      [class.opacity-50]="showComments || showReactions || showCollaborators || showTaggedPeople"
      [class.cursor-pointer]="showComments || showReactions || showCollaborators || showTaggedPeople"
      (click)="(showComments || showReactions || showCollaborators || showTaggedPeople) && closeCommentsAndReactions()">
      <div class="flex items-center gap-3">
        <div class="flex-shrink-0">
          <!-- NO collaborators: Show single large avatar (40px) -->
          <img *ngIf="(post.acceptedCollaborators?.length ?? 0) === 0" class="h-10 w-10 rounded-full object-cover"
            [src]="post.user?.avatar" [alt]="post.user?.name"
            onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />

          <!-- HAS collaborators: Show overlapping avatars (Instagram style - max 2 avatars + badge) -->
          <div *ngIf="(post.acceptedCollaborators?.length ?? 0) > 0" class="flex -space-x-2 items-center"
            [class.cursor-pointer]="(post.acceptedCollaborators?.length ?? 0) >= 1"
            (click)="(post.acceptedCollaborators?.length ?? 0) >= 1 ? openCollaborators() : null; $event.stopPropagation()">

            <!-- Author avatar (always first) -->
            <img class="h-9 w-9 rounded-full object-cover border-2 border-white" [src]="post.user?.avatar"
              [alt]="post.user?.name"
              onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />

            <!-- Show ONLY first collaborator avatar -->
            <img class="h-7 w-7 rounded-full object-cover border-2 border-white"
              [src]="post.acceptedCollaborators?.[0]?.profileImage?.urlSmall"
              [alt]="post.acceptedCollaborators?.[0]?.displayName"
              onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
          </div>
        </div>




        <div class="flex-1 min-w-0">
          <div class="flex gap-[10px] font-semibold text-gray-700 text-base">
            <span class="cursor-pointer" (click)="$event.stopPropagation()"
              [routerLink]="['/profile', post.user?.name, 'post']">{{ post.user?.name }}</span>

            <!-- 1 collaborator: show name -->
            <ng-container *ngIf="(post.acceptedCollaborators?.length ?? 0) === 1">
              <span class="font-normal text-gray-500"> with </span>
              <span class="font-semibold text-gray-700 cursor-pointer" (click)="$event.stopPropagation()"
                [routerLink]="['/profile', post.acceptedCollaborators?.[0]?.userName, 'post']">{{
                post.acceptedCollaborators?.[0]?.userName }}</span>
            </ng-container>

            <!-- 2+ collaborators: show "X others" (clickable) -->
            <ng-container *ngIf="(post.acceptedCollaborators?.length ?? 0) >= 2">
              <span class="font-normal text-gray-500"> and </span>
              <span class="font-semibold text-gray-700 cursor-pointer hover:text-gray-900"
                (click)="openCollaborators(); $event.stopPropagation()">
                {{ post.acceptedCollaborators?.length ?? 0 }} {{ (post.acceptedCollaborators?.length ?? 0) === 1 ?
                'other' : 'others'
                }}
              </span>
            </ng-container>

            <button (click)="onFriendButtonClick(post, $event)"
              *ngIf="!post.isMyPost && post.acceptedCollaborators.length === 0"
              [disabled]="post.friendship.status === 'BLOCKED'" [title]="friendButtonTitle(post.friendship.status)"
              class="text-gray-400 flex-shrink-0 transition-colors
         disabled:opacity-40 disabled:cursor-not-allowed hover:text-[#D31148]">

              <!-- NONE: add friend -->
              <svg *ngIf="post.friendship.status === 'NONE'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#D31148" stroke-width="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="19" y1="8" x2="19" y2="14" />
                <line x1="22" y1="11" x2="16" y2="11" />
              </svg>

              <!-- PENDING_SENT: request sent — click to cancel -->
              <svg *ngIf="post.friendship.status === 'PENDING_SENT'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#f97316" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="17" y1="8" x2="23" y2="14" />
                <line x1="23" y1="8" x2="17" y2="14" />
              </svg>

              <!-- PENDING_RECEIVED: they sent you a request -->
              <svg *ngIf="post.friendship.status === 'PENDING_RECEIVED'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
              </svg>

              <!-- FRIENDS: already friends — click to unfriend -->
              <svg *ngIf="post.friendship.status === 'FRIENDS'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
              </svg>

              <!-- BLOCKED -->
              <svg *ngIf="post.friendship.status === 'BLOCKED'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
              </svg>

            </button>
          </div>

          <div class="text-sm text-gray-400" *ngIf="post.user?.location">{{ post.user?.location }}</div>
        </div>
      </div>

      <div class="flex justify-between items-center gap-2">
        <div class="flex gap-2">
          <button *ngIf="!post.isMyPost && !post.isFollowed && post.acceptedCollaborators.length === 0"
            (click)="follow($event, post)"
            class="px-3 py-1.5 text-sm font-medium text-green-700 bg-green-100 border border-green-600 rounded-lg transition flex-shrink-0 hover:bg-green-200">
            Follow
          </button>
        </div>

        <!-- Three-dot action menu -->
        <div class="relative inline-block">
          <button (click)="toggleActionMenu($event)"
            class="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-200 transition-colors text-gray-500">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M10.2441 6C10.2441 5.0335 11.0276 4.25 11.9941 4.25H12.0041C12.9706 4.25 13.7541 5.0335 13.7541 6C13.7541 6.9665 12.9706 7.75 12.0041 7.75H11.9941C11.0276 7.75 10.2441 6.9665 10.2441 6ZM10.2441 18C10.2441 17.0335 11.0276 16.25 11.9941 16.25H12.0041C12.9706 16.25 13.7541 17.0335 13.7541 18C13.7541 18.9665 12.9706 19.75 12.0041 19.75H11.9941C11.0276 19.75 10.2441 18.9665 10.2441 18ZM11.9941 10.25C11.0276 10.25 10.2441 11.0335 10.2441 12C10.2441 12.9665 11.0276 13.75 11.9941 13.75H12.0041C12.9706 13.75 13.7541 12.9665 13.7541 12C13.7541 11.0335 12.9706 10.25 12.0041 10.25H11.9941Z" />
            </svg>
          </button>
          <app-dropdown [isOpen]="showActionMenu" (close)="closeActionMenu()" className="w-44 p-2 right-0">
            <!-- Author actions -->
            <ng-container>
              <app-dropdown-item *ngIf="post.isMyPost" (itemClick)="toggleComments(); closeActionMenu()"
                [className]="(commentsDisabled ? 'flex w-full font-normal text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700 px-3 py-2 gap-2' : 'flex w-full font-normal text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800 px-3 py-2 gap-2') + (togglingComments ? ' opacity-50 pointer-events-none' : '')">
                <!-- Comments currently ON -->
                <svg *ngIf="!commentsDisabled" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="flex-shrink-0">
                  <path
                    d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                </svg>
                <!-- Comments currently OFF -->
                <svg *ngIf="commentsDisabled" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="flex-shrink-0">
                  <path
                    d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                  <line x1="2" y1="2" x2="22" y2="22" />
                </svg>
                {{ commentsDisabled ? 'Turn on comments' : 'Turn off comments' }}
              </app-dropdown-item>
              <app-dropdown-item *ngIf="post.isMyPost" (itemClick)="editPost(); closeActionMenu()"
                className="flex w-full font-normal text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800 px-3 py-2 gap-2">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Edit Post
              </app-dropdown-item>
              <app-dropdown-item *ngIf="post.isMyPost" (itemClick)="confirmDelete(); closeActionMenu()"
                className="flex w-full font-normal text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700 px-3 py-2 gap-2">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                  <polyline points="3 6 5 6 21 6" />
                  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                  <path d="M10 11v6" />
                  <path d="M14 11v6" />
                  <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                </svg>
                Delete Post
              </app-dropdown-item>
              <app-dropdown-item *ngIf="!post.isMyPost && post.isFollowed && post.acceptedCollaborators.length === 0"
                (itemClick)="unfollow(undefined, post); closeActionMenu()"
                className="flex w-full font-normal text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800 px-3 py-2 gap-2">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <line x1="17" y1="11" x2="23" y2="11" />
                </svg>
                Unfollow
              </app-dropdown-item>
              <app-dropdown-item *ngIf="!post.isMyPost" (itemClick)="reportPost()"
                className="flex w-full font-normal text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700 px-3 py-2 gap-2">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                  <polyline points="3 6 5 6 21 6" />
                  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                  <path d="M10 11v6" />
                  <path d="M14 11v6" />
                  <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                </svg>
                Report Post
              </app-dropdown-item>
              <app-dropdown-item *ngIf="!post.isMyPost" (itemClick)="blockPostUser()"
                className="flex w-full font-normal text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700 px-3 py-2 gap-2">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                </svg>
                Block User
              </app-dropdown-item>
            </ng-container>
            <!-- Collaborator-only action -->
            <ng-container *ngIf="!post.isMyPost && isCollaborator">
              <app-dropdown-item (itemClick)="confirmLeave(); closeActionMenu()"
                className="flex w-full font-normal text-left text-orange-500 rounded-lg hover:bg-orange-50 hover:text-orange-700 px-3 py-2 gap-2">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                Leave Collaboration
              </app-dropdown-item>
            </ng-container>
          </app-dropdown>
        </div>
      </div>
    </div>

    <!-- POST VIEW (when NOT in comments or reactions) -->
    <div *ngIf="!showComments && !showReactions && !showCollaborators && !showTaggedPeople" class="flex-1 overflow-y-auto"
      style="scrollbar-width:thin;scrollbar-color:#d1d1d1 #f1f1f1">

      <!-- ── Collaboration invite banner ── -->
      <div *ngIf="myCollabStatus === 'PENDING'"
        class="mx-4 mt-4 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 flex flex-col gap-2.5">
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </div>
          <div class="flex-1 min-w-0">
            <p class="text-sm font-semibold text-amber-800">Collaboration Invite</p>
            <p class="text-xs text-amber-700 mt-0.5 leading-snug">
              You've been invited to collaborate on this post. Accept to appear as a co-creator.
            </p>
          </div>
        </div>
        <div class="flex gap-2">
          <button (click)="acceptCollaboration()"
            [disabled]="isCollabActioning"
            class="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-[#D31148] text-white text-sm font-semibold disabled:opacity-50 hover:bg-[#b50e3c] transition-colors">
            <svg *ngIf="!isCollabActioning" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            <svg *ngIf="isCollabActioning" class="animate-spin" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5">
              <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
            </svg>
            Accept
          </button>
          <button (click)="declineCollaboration()"
            [disabled]="isCollabActioning"
            class="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl border border-gray-200 bg-white text-gray-600 text-sm font-semibold disabled:opacity-50 hover:bg-gray-50 transition-colors">
            <svg *ngIf="!isCollabActioning" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
            Decline
          </button>
        </div>
      </div>

      <!-- ── Collaboration accepted confirmation ── -->
      <!-- <div *ngIf="myCollabStatus === 'ACCEPTED'"
        class="mx-4 mt-4 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 flex items-center gap-3">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#059669" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        <p class="text-sm font-medium text-emerald-800">You are a collaborator on this post.</p>
      </div> -->
      <div *ngIf="post.media.length > 0" class="relative bg-gray-900">
        <div class="relative w-full overflow-hidden select-none" appSwipe [swipeDisabled]="post.media.length <= 1"
          (swipeLeft)="nextSlide()" (swipeRight)="prevSlide()">
          <ng-container *ngFor="let media of post.media; let i = index">
            <img *ngIf="media.type === 'image'" [src]="media.url" [alt]="'Slide ' + (i + 1)"
              class="w-full h-auto object-contain transition-opacity duration-300"
              [class.opacity-100]="i === post.activeSlide" [class.opacity-0]="i !== post.activeSlide"
              [class.pointer-events-none]="i !== post.activeSlide" [class.absolute]="i !== post.activeSlide"
              [class.relative]="i === post.activeSlide" style="max-height: 70vh;" />
            <video *ngIf="media.type === 'video'" [src]="media.url"
              class="w-full h-auto object-contain transition-opacity duration-300"
              [class.opacity-100]="i === post.activeSlide" [class.opacity-0]="i !== post.activeSlide"
              [class.pointer-events-none]="i !== post.activeSlide" [class.absolute]="i !== post.activeSlide"
              [class.relative]="i === post.activeSlide" style="max-height: 70vh;" controls muted playsinline></video>
          </ng-container>

          <ng-container *ngIf="post.media.length > 1">
            <button (click)="prevSlide($event)"
              class="absolute left-3 top-1/2 -translate-y-1/2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-gray-800 shadow-lg hover:bg-white transition-all">
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <button (click)="nextSlide($event)"
              class="absolute right-3 top-1/2 -translate-y-1/2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-gray-800 shadow-lg hover:bg-white transition-all">
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </ng-container>
        </div>

        <div *ngIf="post.media.length > 1"
          class="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-1.5 z-10">
          <button *ngFor="let media of post.media; let i = index" (click)="goToSlide(i, $event)"
            class="rounded-full transition-all duration-300"
            [class]="i === post.activeSlide ? 'h-2 w-6 bg-white' : 'h-2 w-2 bg-white/50'">
          </button>
        </div>
      </div>

      <!-- Background Post (no media) -->
      <div *ngIf="post.media.length === 0 && post.hasBackground"
        class="relative mt-4 mx-5 rounded-2xl overflow-hidden flex items-center justify-center"
        [style.min-height]="post.description.length < 100 ? '240px' : '70vh'"
        [style.max-height]="post.description.length > 500 ? '420px' : '360px'"
        [ngClass]="getPatternClass(post.backgroundPattern)" [style.background-color]="post.backgroundBg">
        <div class="absolute inset-0 px-5 py-5 overflow-y-auto custom-scrollbar"
          [class.flex]="post.description.length < 100" [class.items-center]="post.description.length < 100"
          [class.justify-center]="post.description.length < 100">
          <p class="text-xl font-bold leading-snug text-white background-text"
            [class.text-center]="post.description.length < 100"
            style="text-shadow: 0 1px 5px rgba(0,0,0,0.3); white-space: pre-wrap; word-wrap: break-word;"
            [innerHTML]="post.description | mentionHighlight" (click)="onMentionClick($event)">
          </p>
        </div>
      </div>

      <ng-container *ngIf="totalReactions > 0">
        <button class="flex px-5 items-center mt-3 gap-1.5 cursor-pointer hover:opacity-80 transition-opacity"
          (click)="openReactions(); $event.stopPropagation()">
          <!-- Stacked emoji bubbles for top reaction types -->
          <span class="flex items-center" style="gap:-4px;">
            <span *ngFor="let t of topTypes; let i = index"
              class="flex items-center justify-center rounded-full border-2 border-white shadow-sm"
              [style.background]="getReactionConfig(t)?.bg" [style.width]="'22px'" [style.height]="'22px'"
              [style.font-size]="'13px'" [style.line-height]="'1'" [style.margin-left]="i > 0 ? '-6px' : '0'"
              [style.z-index]="10 - i">
              {{ getReactionConfig(t)?.emoji }}
            </span>
          </span>
          <!-- "Name and X others" or just count -->
          <span class="text-sm text-gray-500">
            <ng-container *ngIf="recentUserName">
              <span class="font-medium text-gray-700">{{ recentUserName }}</span>
              <ng-container *ngIf="totalReactions > 1">
                and {{ totalReactions - 1 }} {{ totalReactions - 1 === 1 ? 'other' : 'others' }}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!recentUserName">
              {{ totalReactions }}
            </ng-container>
          </span>
        </button>
      </ng-container>

      <!-- Action Bar -->
      <div class="flex items-center justify-between px-5 py-3 border-b border-gray-100">
        <div class="flex items-center gap-4">
          <!-- Reaction Button -->
          <div class="relative flex items-center gap-1 select-none" style="overflow:visible;">
            <div *ngIf="showEmojiPicker"
              class="reaction-picker absolute z-[999] flex items-end gap-1 rounded-full bg-white px-3 py-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.2)] border border-gray-100"
              style="bottom:calc(100% + 10px);left:-8px;pointer-events:auto;" (mouseleave)="closeEmojiPickerBar()">
              <button *ngFor="let r of REACTIONS; let i = index" (click)="onEmojiPick(r.type, $event)"
                (mouseenter)="hoveredReaction = r.type" (mouseleave)="hoveredReaction = null"
                class="reaction-emoji-btn flex flex-col items-center cursor-pointer" [style.animation-delay.ms]="i * 30"
                [title]="r.label">
                <span class="reaction-circle flex items-center justify-center rounded-full" [style.background]="r.bg"
                  [class.scale-125]="hoveredReaction === r.type" [class.-translate-y-2]="hoveredReaction === r.type"
                  style="width:42px;height:42px;font-size:22px;line-height:1;transition:transform 0.15s cubic-bezier(0.34,1.56,0.64,1);">
                  {{ r.emoji }}
                </span>
              </button>
            </div>
            <button (click)="onReactionClick()"
              class="reaction-trigger flex items-center gap-1.5 rounded-lg px-1 py-0.5 transition-all duration-150 active:scale-90">
              <ng-container *ngIf="!myReaction">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g opacity="0.7">
                    <path
                      d="M7.48047 18.35L10.5805 20.75C10.9805 21.15 11.8805 21.35 12.4805 21.35H16.2805C17.4805 21.35 18.7805 20.45 19.0805 19.25L21.4805 11.95C21.9805 10.55 21.0805 9.34997 19.5805 9.34997H15.5805C14.9805 9.34997 14.4805 8.84997 14.5805 8.14997L15.0805 4.94997C15.2805 4.04997 14.6805 3.04997 13.7805 2.74997C12.9805 2.44997 11.9805 2.84997 11.5805 3.44997L7.48047 9.54997"
                      stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" />
                    <path
                      d="M2.37988 18.35V8.55002C2.37988 7.15002 2.97988 6.65002 4.37988 6.65002H5.37988C6.77988 6.65002 7.37988 7.15002 7.37988 8.55002V18.35C7.37988 19.75 6.77988 20.25 5.37988 20.25H4.37988C2.97988 20.25 2.37988 19.75 2.37988 18.35Z"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                </svg>
                <span class="text-sm text-gray-400">{{ totalReactions }}</span>
              </ng-container>
              <ng-container *ngIf="myReaction">
                <span class="reaction-bounce flex items-center justify-center rounded-full"
                  [style.background]="getReactionConfig(myReaction)?.bg"
                  style="width:30px;height:30px;font-size:18px;line-height:1;">
                  {{ getReactionConfig(myReaction)?.emoji }}
                </span>
                <span class="text-sm font-semibold" [style.color]="getReactionConfig(myReaction)?.color">
                  {{ totalReactions }}
                </span>
              </ng-container>
            </button>
          </div>

          <!-- Comment Button -->
          <button (click)="openComments()"
            class="flex items-center gap-1.5 transition-colors text-gray-600 hover:text-[#D31148]">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g opacity="0.7">
                <path
                  d="M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </g>
            </svg>
            <span class="text-sm font-medium">{{ commentCount }}</span>
          </button>

          <!-- Share Button -->
          <button class="flex items-center gap-1.5 text-gray-600 hover:text-[#D31148] transition-colors"
            (click)="openShareSheet()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g opacity="0.7">
                <path
                  d="M20.7914 12.6075C21.0355 12.3982 21.1575 12.2936 21.2023 12.1691C21.2415 12.0598 21.2415 11.9403 21.2023 11.831C21.1575 11.7065 21.0355 11.6019 20.7914 11.3926L12.3206 4.13202C11.9004 3.77182 11.6903 3.59172 11.5124 3.58731C11.3578 3.58348 11.2101 3.6514 11.1124 3.77128C11 3.90921 11 4.18595 11 4.73942V9.03468C8.86532 9.40813 6.91159 10.4898 5.45971 12.1139C3.87682 13.8846 3.00123 16.176 3 18.551V19.163C4.04934 17.8989 5.35951 16.8766 6.84076 16.166C8.1467 15.5395 9.55842 15.1684 11 15.0706V19.2607C11 19.8141 11 20.0909 11.1124 20.2288C11.2101 20.3487 11.3578 20.4166 11.5124 20.4128C11.6903 20.4084 11.9004 20.2283 12.3206 19.8681L20.7914 12.6075Z"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </g>
            </svg>
            <span class="text-sm font-medium">{{ shareCount }}</span>
          </button>
        </div>

        <!-- Right Side Reaction Button -->
        <div class="flex items-center gap-3">
          <!-- Tagged people -->
          <button *ngIf="(post.rawMentions?.length ?? 0) > 0" type="button"
            (click)="openTaggedPeople($event); $event.stopPropagation()" title="Tagged people"
            class="flex items-center justify-center text-gray-300 transition-colors hover:text-[#D31148]">
            <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </button>
          <!-- Favourite star — bottom right -->
          <button (click)="toggleFavourite(); $event.stopPropagation()"
            [class.text-[#D31148]]="isFavourite" [class.text-gray-300]="!isFavourite"
            [title]="isFavourite ? 'Remove from favourites' : 'Save to favourites'"
            class="flex items-center justify-center transition-colors hover:text-[#D31148]">
            <svg class="h-5 w-5" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round"
              [attr.fill]="isFavourite ? 'currentColor' : 'none'">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Description (hide for background-only posts to avoid duplicate text/hashtags) -->
      <div class="px-5 py-4">
        <div class="mb-3" *ngIf="!post.hasBackground">
          <div class="text-sm text-gray-700 leading-relaxed " [class.line-clamp-3]="!post.isExpanded">
            <span class="font-semibold text-lg">{{ post.user.name }}</span> &nbsp;
            <span style="white-space: pre-wrap; word-wrap: break-word;"
              [innerHTML]="post.description | mentionHighlight" (click)="onMentionClick($event)"></span>
          </div>
          <button *ngIf="!post.isExpanded && post.description.length > 150" (click)="toggleExpandPost()"
            class="text-sm font-semibold text-gray-500 mt-1 hover:text-gray-700">
            ...more
          </button>

          <!-- Open Graph card for the first link in the caption — media posts
               only; background posts deliberately don't get a link preview. -->
          <app-link-preview [text]="post.description" [enabled]="post.media.length > 0"
            [debounceMs]="0"></app-link-preview>
        </div>

        <!-- Hashtags -->
        <div *ngIf="post.hashtags && post.hashtags.length > 0">
          <div class="flex flex-wrap gap-1.5">
            <span *ngFor="let tag of post.hashtags" (click)="goToHashtag(tag, $event)"
              class="inline-block text-sm font-medium text-[#D31148] hover:underline cursor-pointer">
              #{{ tag }}
            </span>
          </div>
        </div>

        <p class="text-xs text-gray-400 mt-2">{{ post.timeAgo }}</p>
      </div>
    </div>
    <!-- COMMENTS VIEW (when IN comments - shows image peek at top) -->
    <div *ngIf="showComments && !showReactions && !showCollaborators && !showTaggedPeople" class="flex-1 flex flex-col overflow-hidden">

      <!-- Image Peek at Top with Opacity -->
      <div *ngIf="post.media.length > 0"
        class="relative bg-gray-900 flex-shrink-0 opacity-50 cursor-pointer overflow-hidden" style="height: 155px;"
        (click)="closeComments()">
        <img [src]="post.media[post.activeSlide].url" [alt]="post.user.name" class="w-full h-full object-cover" />
        <div class="absolute inset-0 bg-black/20"></div>
      </div>

      <div *ngIf="post.media.length === 0 && post.hasBackground"
        class="relative flex-shrink-0 opacity-50 cursor-pointer overflow-hidden" style="height: 200px;"
        [ngClass]="getPatternClass(post.backgroundPattern)" [style.background-color]="post.backgroundBg"
        (click)="closeComments()">
        <div class="absolute inset-0 bg-black/20"></div>
        <div class="absolute inset-0 px-4 py-4 overflow-y-auto custom-scrollbar">
          <p class="text-base font-semibold text-white background-text"
            style="text-shadow: 0 1px 5px rgba(0,0,0,0.3); white-space: pre-wrap; word-wrap: break-word;"
            [innerHTML]="post.description | mentionHighlight" (click)="onMentionClick($event)">
          </p>
        </div>
      </div>

      <!-- Comments Header with White Background and Rounded Top Corners -->
      <div
        class="flex items-center justify-center py-4 bg-white border-b border-gray-100 flex-shrink-0 rounded-t-3xl relative"
        style="margin-top: -57px; z-index: 20;">
        <h3 class="font-bold text-gray-900 text-base">Comments</h3>
        <button type="button" (click)="closeComments()" aria-label="Close comments"
          class="absolute right-4 top-1/2 -translate-y-1/2 flex h-7 w-7 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>

      <!-- Comments List -->
      <div class="flex-1 overflow-y-auto px-4 py-4 space-y-4 bg-white"
        style="scrollbar-width:thin;scrollbar-color:#d1d1d1 #f1f1f1">

        <!-- Loading skeleton -->
        <ng-container *ngIf="commentsLoading && !commentsLoaded">
          <div *ngFor="let s of [1,2,3]" class="flex gap-3 animate-pulse">
            <div class="w-9 h-9 rounded-full bg-gray-200 flex-shrink-0"></div>
            <div class="flex-1 space-y-2">
              <div class="h-3 bg-gray-200 rounded w-32"></div>
              <div class="h-3 bg-gray-200 rounded w-full"></div>
              <div class="h-3 bg-gray-200 rounded w-3/4"></div>
            </div>
          </div>
        </ng-container>

        <!-- Empty state -->
        <div *ngIf="!commentsLoading && commentsLoaded && comments.length === 0"
          class="flex flex-col items-center justify-center py-12 text-center">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D31148" stroke-width="1.3"
            stroke-linecap="round" stroke-linejoin="round" class="opacity-30 mb-3">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
          <p class="text-sm text-gray-400 font-medium">No comments yet</p>
          <p class="text-xs text-gray-400 mt-0.5">Be the first to join the conversation</p>
        </div>

        <!-- Comment list -->
        <ng-container *ngFor="let comment of comments">
          <div class="flex gap-3">
            <img [src]="getUserAvatar(comment)" [alt]="comment.user.displayName"
              (click)="$event.stopPropagation()" [routerLink]="['/profile', comment.user.userName, 'post']"
              class="w-9 h-9 rounded-full object-cover flex-shrink-0 mt-0.5 cursor-pointer" />
            <div class="flex-1 min-w-0">

              <!-- Comment header -->
              <div class="flex items-center justify-between mb-1 gap-2">
                <div class="flex items-center gap-2 min-w-0">
                  <span class="text-sm font-bold text-gray-900 truncate cursor-pointer"
                    (click)="$event.stopPropagation()"
                    [routerLink]="['/profile', comment.user.userName, 'post']">{{ comment.user.displayName }}</span>
                  <span class="text-xs text-gray-400 whitespace-nowrap">{{ getTimeAgo(comment.createdAt) }}</span>
                  <span *ngIf="comment.isEdited" class="text-[10px] text-gray-400 italic">(edited)</span>
                </div>
                <div class="flex items-center gap-2 flex-shrink-0">
                  <!-- Reply button -->
                  <button *ngIf="comment.ableToReply && !commentsDisabled" (click)="toggleReply(comment._id)"
                    class="text-xs font-semibold transition-colors" [class.text-[#D31148]]="replyingTo === comment._id"
                    [class.text-gray-500]="replyingTo !== comment._id"
                    [class.hover:text-[#D31148]]="replyingTo !== comment._id">
                    Reply
                  </button>
                  <!-- Edit/Delete/Report dropdown -->
                  <ng-container *ngIf="comment.ableToModification || canReportComment(comment)">
                    <div class="relative inline-block">
                      <button class="dropdown-toggle" (click)="toggleDropdown(comment._id); $event.stopPropagation()">
                        <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none"
                          class="text-gray-400 hover:text-gray-700 size-6">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M10.2441 6C10.2441 5.0335 11.0276 4.25 11.9941 4.25H12.0041C12.9706 4.25 13.7541 5.0335 13.7541 6C13.7541 6.9665 12.9706 7.75 12.0041 7.75H11.9941C11.0276 7.75 10.2441 6.9665 10.2441 6ZM10.2441 18C10.2441 17.0335 11.0276 16.25 11.9941 16.25H12.0041C12.9706 16.25 13.7541 17.0335 13.7541 18C13.7541 18.9665 12.9706 19.75 12.0041 19.75H11.9941C11.0276 19.75 10.2441 18.9665 10.2441 18ZM11.9941 10.25C11.0276 10.25 10.2441 11.0335 10.2441 12C10.2441 12.9665 11.0276 13.75 11.9941 13.75H12.0041C12.9706 13.75 13.7541 12.9665 13.7541 12C13.7541 11.0335 12.9706 10.25 12.0041 10.25H11.9941Z"
                            fill="currentColor"></path>
                        </svg>
                      </button>

                      <app-dropdown [isOpen]="openDropdownId === comment._id" (close)="closeDropdown()"
                        className="w-40 p-2">
                        <ng-container *ngIf="comment.ableToModification; else reportCommentItem">
                          <app-dropdown-item (itemClick)="startEdit(comment); closeDropdown()"
                            className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                            Edit
                          </app-dropdown-item>
                          <app-dropdown-item (itemClick)="deleteComment(comment._id); closeDropdown()"
                            className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                            Delete
                          </app-dropdown-item>
                        </ng-container>
                        <ng-template #reportCommentItem>
                          <app-dropdown-item (itemClick)="reportComment(comment._id)"
                            className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                            Report
                          </app-dropdown-item>
                        </ng-template>
                      </app-dropdown>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Edit mode -->
              <ng-container *ngIf="editingCommentId === comment._id; else commentBody">
                <div class="flex gap-2 mt-1 items-center">
                  <button (click)="toggleEmojiPicker($event, 'main')"
                    class="text-gray-400 hover:text-[#D31148] transition-colors flex-shrink-0"
                    [class.text-[#D31148]]="showCommentEmojiPicker">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10" />
                      <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                      <line x1="9" y1="9" x2="9.01" y2="9" />
                      <line x1="15" y1="9" x2="15.01" y2="9" />
                    </svg>
                  </button>
                  <input [(ngModel)]="editInput" type="text"
                    class="flex-1 text-sm border border-[#D31148] rounded-lg px-3 py-1.5 outline-none bg-white" />
                  <button (click)="saveEdit(comment)" [disabled]="submitting" class="px-3 py-1.5 rounded-lg bg-[#D31148] text-white text-xs font-bold
                                 hover:bg-[#b80e3d] transition-colors disabled:opacity-50">
                    Save
                  </button>
                  <button (click)="cancelEdit()" class="px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-semibold
                                 text-gray-600 hover:bg-gray-50 transition-colors">
                    Cancel
                  </button>
                </div>
              </ng-container>

              <!-- Normal comment body -->
              <ng-template #commentBody>
                <p *ngIf="getTextPart(comment.body)"
                  class="text-sm text-gray-600 leading-relaxed break-words overflow-wrap-break-word"
                  [innerHTML]="getTextPart(comment.body) | mentionHighlight">
                </p>
                <img *ngIf="getGifPart(comment.body)" [src]="getGifPart(comment.body)" alt="GIF"
                  class="mt-2 rounded-xl max-h-40 object-cover border border-gray-100" />
              </ng-template>

              <!-- Reply input box -->
              <div *ngIf="replyingTo === comment._id" [id]="'reply-input-' + comment._id" class="mt-3 relative">

                <!-- @mention dropdown -->
                <app-mention-dropdown [isOpen]="showMentionDropdown && activeMentionContext === comment._id"
                  [users]="mentionUsers" (selected)="onMentionPicked($event, comment._id, replyDir)">
                </app-mention-dropdown>

                <div *ngIf="replyGifUrls[comment._id]" class="mb-2">
                  <div class="relative inline-block">
                    <img [src]="replyGifUrls[comment._id]" alt="Selected GIF"
                      class="h-16 rounded-xl border border-gray-200 object-cover" />
                    <button (click)="removeGif(comment._id)" class="absolute -top-1.5 -right-1.5 w-5 h-5 flex items-center justify-center
                                   rounded-full bg-gray-800 text-white text-xs hover:bg-red-500 transition-colors">
                      ×
                    </button>
                  </div>
                </div>

                <div class="flex gap-2">
                  <!-- Emoji button -->
                  <button (click)="toggleEmojiPicker($event, comment._id)"
                    class="text-gray-400 hover:text-[#D31148] transition-colors flex-shrink-0"
                    [class.text-[#D31148]]="showCommentEmojiPicker">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10" />
                      <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                      <line x1="9" y1="9" x2="9.01" y2="9" />
                      <line x1="15" y1="9" x2="15.01" y2="9" />
                    </svg>
                  </button>

                  <!-- Reply input with mention directive -->
                  <div #replyDir="appMentionInput" appMentionInput contenteditable="true" role="textbox"
                    aria-multiline="false" [attr.data-placeholder]="'Write a reply… type @ to mention'"
                    (mentionEnter)="submitReply(comment._id)" (mentionSearch)="onMentionSearch($event, comment._id)"
                    (mentionDropdown)="onMentionDropdownChange($event, comment._id)"
                    (valueChange)="replyInputs[comment._id] = $event" class="mention-editable comment-mention-input flex-1 text-sm text-gray-700 outline-none
                              border border-gray-200 focus:border-[#D31148]
                              rounded-xl px-3 py-1.5 transition-colors bg-[#f7f7f7]">
                  </div>

                  <button (click)="toggleGifPicker(comment._id, $event)" class="text-xs font-black text-gray-400 hover:text-[#D31148]
                                 transition-colors flex-shrink-0 px-1 leading-none"
                    [class.text-[#D31148]]="showGifPicker && activeEmojiContext === comment._id">
                    GIF
                  </button>

                  <!-- Send button -->
                  <button (click)="submitReply(comment._id)"
                    [disabled]="submitting || (!replyInputs[comment._id]?.trim() && !replyGifUrls[comment._id])" class="w-8 h-8 flex items-center justify-center rounded-full bg-[#D31148]
                                 text-white hover:bg-[#b80e3d] transition-colors disabled:opacity-50">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                      stroke-linecap="round" stroke-linejoin="round">
                      <line x1="22" y1="2" x2="11" y2="13" />
                      <polygon points="22 2 15 22 11 13 2 9 22 2" />
                    </svg>
                  </button>
                </div>
              </div>

              <!-- Replies -->
              <ng-container *ngIf="comment.replies && comment.replies.length > 0">
                <div class="mt-3 pl-3 border-l-2 border-[#FFD4E0] space-y-3">
                  <div *ngFor="let reply of comment.replies" class="flex gap-2.5">
                    <img [src]="getUserAvatar(reply)" [alt]="reply.user.displayName"
                      (click)="$event.stopPropagation()" [routerLink]="['/profile', reply.user.userName, 'post']"
                      class="w-8 h-8 rounded-full object-cover flex-shrink-0 mt-0.5 cursor-pointer" />
                    <div class="flex-1 min-w-0">
                      <div class="flex items-center justify-between mb-1 gap-2">
                        <div class="flex items-center gap-2 min-w-0">
                          <span class="text-sm font-bold text-gray-900 truncate cursor-pointer"
                            (click)="$event.stopPropagation()"
                            [routerLink]="['/profile', reply.user.userName, 'post']">{{ reply.user.displayName }}</span>
                          <span class="text-xs text-gray-400 whitespace-nowrap">{{ getTimeAgo(reply.createdAt) }}</span>
                          <span *ngIf="reply.isEdited" class="text-[10px] text-gray-400 italic">(edited)</span>
                        </div>
                        <div class="flex items-center gap-2 flex-shrink-0">
                          <!-- Edit/Delete/Report for reply -->
                          <ng-container *ngIf="reply.ableToModification || canReportComment(reply)">
                            <div class="relative inline-block">
                              <button class="dropdown-toggle"
                                (click)="toggleDropdown(reply._id); $event.stopPropagation()">
                                <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none"
                                  class="text-gray-400 hover:text-gray-700 size-6">
                                  <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M10.2441 6C10.2441 5.0335 11.0276 4.25 11.9941 4.25H12.0041C12.9706 4.25 13.7541 5.0335 13.7541 6C13.7541 6.9665 12.9706 7.75 12.0041 7.75H11.9941C11.0276 7.75 10.2441 6.9665 10.2441 6ZM10.2441 18C10.2441 17.0335 11.0276 16.25 11.9941 16.25H12.0041C12.9706 16.25 13.7541 17.0335 13.7541 18C13.7541 18.9665 12.9706 19.75 12.0041 19.75H11.9941C11.0276 19.75 10.2441 18.9665 10.2441 18ZM11.9941 10.25C11.0276 10.25 10.2441 11.0335 10.2441 12C10.2441 12.9665 11.0276 13.75 11.9941 13.75H12.0041C12.9706 13.75 13.7541 12.9665 13.7541 12C13.7541 11.0335 12.9706 10.25 12.0041 10.25H11.9941Z"
                                    fill="currentColor"></path>
                                </svg>
                              </button>

                              <app-dropdown [isOpen]="openDropdownId === reply._id" (close)="closeDropdown()"
                                className="w-40 p-2">
                                <ng-container *ngIf="reply.ableToModification; else reportReplyItem">
                                  <app-dropdown-item (itemClick)="startEdit(reply); closeDropdown()"
                                    className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                                    Edit
                                  </app-dropdown-item>
                                  <app-dropdown-item (itemClick)="deleteComment(reply._id, comment._id); closeDropdown()"
                                    className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                                    Delete
                                  </app-dropdown-item>
                                </ng-container>
                                <ng-template #reportReplyItem>
                                  <app-dropdown-item (itemClick)="reportComment(reply._id)"
                                    className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                                    Report
                                  </app-dropdown-item>
                                </ng-template>
                              </app-dropdown>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                      <!-- Edit mode for reply -->
                      <ng-container *ngIf="editingCommentId === reply._id; else replyBody">
                        <div class="flex gap-2 mt-1">
                          <input [(ngModel)]="editInput" type="text"
                            class="flex-1 text-sm border border-[#D31148] rounded-lg px-3 py-1.5 outline-none bg-white" />
                          <button (click)="saveEdit(reply)" [disabled]="submitting" class="px-3 py-1.5 rounded-lg bg-[#D31148] text-white text-xs font-bold
                                         hover:bg-[#b80e3d] transition-colors disabled:opacity-50">Save</button>
                          <button (click)="cancelEdit()" class="px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-semibold
                                         text-gray-600 hover:bg-gray-50 transition-colors">Cancel</button>
                        </div>
                      </ng-container>
                      <ng-template #replyBody>
                        <p *ngIf="getTextPart(reply.body)"
                          class="text-sm text-gray-600 leading-relaxed break-words overflow-wrap-break-word"
                          [innerHTML]="getTextPart(reply.body) | mentionHighlight">
                        </p>
                        <img *ngIf="getGifPart(reply.body)" [src]="getGifPart(reply.body)" alt="GIF"
                          class="mt-2 rounded-xl max-h-32 object-cover border border-gray-100" />
                      </ng-template>
                    </div>
                  </div>
                </div>
              </ng-container>

            </div>
          </div>
        </ng-container>

        <!-- Load more -->
        <div *ngIf="commentsPage < commentsTotalPages" class="flex justify-center pt-2 pb-1">
          <button (click)="loadMoreComments()" [disabled]="commentsLoading"
            class="text-xs font-semibold text-[#D31148] hover:underline disabled:opacity-50">
            {{ commentsLoading ? 'Loading…' : 'Load more comments' }}
          </button>
        </div>

      </div>

      <!-- Comment Input Footer -->
      <div class="flex-shrink-0 border-t border-gray-100 bg-white relative comment-picker-area">

        <!-- Quick emoji bar -->
        <!-- <div class="flex items-center gap-1 px-3 py-2 overflow-x-auto border-b border-gray-50"
          style="-ms-overflow-style:none;scrollbar-width:none">
          <button *ngFor="let e of QUICK_EMOJIS" (click)="appendQuickEmoji(e)"
            class="text-lg flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 hover:scale-110 transition-all">
            {{ e }}
          </button>
        </div> -->

        <!-- GIF preview strip -->
        <div *ngIf="selectedGifUrl" class="flex items-center gap-2 px-3 pt-2">
          <div class="relative inline-block">
            <img [src]="selectedGifUrl" alt="Selected GIF"
              class="h-16 rounded-xl border border-gray-200 object-cover" />
            <button (click)="removeGif()" class="absolute -top-1.5 -right-1.5 w-5 h-5 flex items-center justify-center
                           rounded-full bg-gray-800 text-white text-xs hover:bg-red-500 transition-colors">
              ×
            </button>
          </div>
        </div>

        <!-- Comments disabled banner -->
        <div *ngIf="commentsDisabled"
          class="mx-3 my-3 px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl flex items-center gap-2 text-sm text-gray-500">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
          Comments have been turned off for this post.
        </div>

        <!-- Input row -->
        <div *ngIf="!commentsDisabled" class="flex items-center gap-2 px-3 py-3">
          <img [src]="getCurrentUserAvatar()" alt="me" class="w-8 h-8 rounded-full object-cover flex-shrink-0" />
          <div class="flex-1 relative">

            <!-- @mention dropdown anchored above the main input -->
            <app-mention-dropdown [isOpen]="showMentionDropdown && activeMentionContext === 'main'"
              [users]="mentionUsers" (selected)="onMentionPicked($event, 'main', mainDir)">
            </app-mention-dropdown>

            <div class="flex items-center gap-2 bg-[#f7f7f7] rounded-xl px-3 py-2
                        border border-gray-200 focus-within:border-[#D31148] transition-colors min-w-0">
              <button (click)="toggleEmojiPicker($event, 'main')"
                class="text-gray-400 hover:text-[#D31148] transition-colors flex-shrink-0"
                [class.text-[#D31148]]="showCommentEmojiPicker">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                  <line x1="9" y1="9" x2="9.01" y2="9" />
                  <line x1="15" y1="9" x2="15.01" y2="9" />
                </svg>
              </button>

              <div #mainDir="appMentionInput" appMentionInput contenteditable="true" role="textbox"
                aria-multiline="false" [attr.data-placeholder]="'Join the conversation…'"
                (mentionEnter)="submitComment()" (mentionSearch)="onMentionSearch($event, 'main')"
                (mentionDropdown)="onMentionDropdownChange($event, 'main')" (valueChange)="commentInput = $event"
                class="mention-editable comment-mention-input flex-1 text-sm text-gray-700 outline-none min-w-0">
              </div>

              <button (click)="toggleGifPicker('main', $event)" class="text-xs font-black text-gray-400 hover:text-[#D31148]
                             transition-colors flex-shrink-0 px-1 leading-none" [class.text-[#D31148]]="showGifPicker">
                GIF
              </button>
            </div>
          </div>
          <div class="flex items-center gap-1.5 flex-shrink-0">
            <button (click)="submitComment()" [disabled]="submitting || (!commentInput.trim() && !selectedGifUrl)"
              class="w-8 h-8 flex items-center justify-center rounded-full bg-[#D31148] text-white
                           hover:bg-[#b80e3d] transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <line x1="22" y1="2" x2="11" y2="13" />
                <polygon points="22 2 15 22 11 13 2 9 22 2" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Full emoji picker panel -->
        <div *ngIf="showCommentEmojiPicker" class="absolute bottom-full left-0 right-0 mx-3 mb-1 bg-white rounded-2xl border border-gray-200
                    shadow-xl z-[500] overflow-hidden" (click)="$event.stopPropagation()">
          <div class="flex border-b border-gray-100 px-2 pt-2 gap-1">
            <button *ngFor="let cat of EMOJI_CATEGORIES; let i = index" (click)="setEmojiTab(i)"
              class="px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors"
              [class.bg-[#D31148]]="activeEmojiTab === i" [class.text-white]="activeEmojiTab === i"
              [class.text-gray-500]="activeEmojiTab !== i" [class.hover:bg-gray-100]="activeEmojiTab !== i">
              {{ cat.label }}
            </button>
          </div>
          <div class="flex flex-wrap gap-0.5 p-3 max-h-40 overflow-y-auto">
            <button *ngFor="let emoji of EMOJI_CATEGORIES[activeEmojiTab].emojis" (click)="pickEmoji(emoji)" class="text-xl w-9 h-9 flex items-center justify-center rounded-lg
                           hover:bg-gray-100 hover:scale-110 transition-all">
              {{ emoji }}
            </button>
          </div>
        </div>

        <!-- GIF picker panel -->
        <div *ngIf="showGifPicker" class="absolute bottom-full left-0 right-0 mx-3 mb-1 bg-white rounded-2xl border border-gray-200
                    shadow-xl z-[500] overflow-hidden" (click)="$event.stopPropagation()">
          <div class="flex items-center gap-2 p-3 border-b border-gray-100">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input [(ngModel)]="gifSearchQuery" type="text" placeholder="Search GIFs (powered by GIPHY)…"
              (keyup)="onGifSearchKey($event)"
              class="flex-1 text-sm outline-none text-gray-700 placeholder-gray-400 bg-transparent" />
            <button (click)="searchGifs()" class="text-xs font-bold text-[#D31148] hover:underline">Search</button>
          </div>
          <div class="p-2 max-h-48 overflow-y-auto">
            <div *ngIf="gifLoading" class="flex items-center justify-center py-8">
              <div class="w-6 h-6 border-2 border-[#D31148] border-t-transparent rounded-full animate-spin">
              </div>
            </div>
            <div *ngIf="!gifLoading && gifResults.length === 0" class="py-8 text-center text-sm text-gray-400">
              <p>No GIFs found.</p>
            </div>
            <div *ngIf="!gifLoading && gifResults.length > 0" class="grid grid-cols-3 sm:grid-cols-4 gap-1.5">
              <button *ngFor="let gif of gifResults" (click)="selectGif(gif)"
                class="rounded-xl overflow-hidden hover:ring-2 hover:ring-[#D31148] transition-all aspect-video">
                <img [src]="gif.preview" alt="GIF" class="w-full h-full object-cover" loading="lazy" />
              </button>
            </div>
            <p *ngIf="gifResults.length > 0" class="text-[10px] text-gray-400 text-center pt-2">
              Powered by GIPHY</p>
          </div>
        </div>

      </div>
    </div>
    <!-- REACTIONS VIEW (when IN reactions - shows image peek at top) -->
    <div *ngIf="showReactions && !showComments && !showCollaborators && !showTaggedPeople" class="flex-1 flex flex-col overflow-hidden">

      <!-- Image Peek at Top with Opacity -->
      <div *ngIf="post.media.length > 0"
        class="relative bg-gray-900 flex-shrink-0 opacity-50 cursor-pointer overflow-hidden" style="height: 200px;"
        (click)="closeReactions()">
        <img [src]="post.media[post.activeSlide].url" [alt]="post.user.name" class="w-full h-full object-cover" />
        <div class="absolute inset-0 bg-black/20"></div>
      </div>

      <div *ngIf="post.media.length === 0 && post.hasBackground"
        class="relative flex-shrink-0 opacity-50 cursor-pointer overflow-hidden" style="height: 200px;"
        [ngClass]="getPatternClass(post.backgroundPattern)" [style.background-color]="post.backgroundBg"
        (click)="closeReactions()">
        <div class="absolute inset-0 bg-black/20"></div>
        <div class="absolute inset-0 px-4 py-4 overflow-y-auto custom-scrollbar">
          <p class="text-base font-semibold text-white background-text"
            style="text-shadow: 0 1px 5px rgba(0,0,0,0.3); white-space: pre-wrap; word-wrap: break-word;"
            [innerHTML]="post.description | mentionHighlight" (click)="onMentionClick($event)">
          </p>
        </div>
      </div>

      <!-- Reactions Header with White Background and Rounded Top Corners -->
      <div class="flex-shrink-0 bg-white border-b border-gray-100 rounded-t-3xl relative"
        style="margin-top: -57px; z-index: 20;">
        <div class="flex items-center gap-1 overflow-x-auto px-5 pt-5 pb-3">
          <button (click)="setReactionFilter(null)"
            class="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors"
            [class.text-[#D31148]]="activeReactionFilter === null" [class.border-b-2]="activeReactionFilter === null"
            [class.border-[#D31148]]="activeReactionFilter === null"
            [class.text-gray-500]="activeReactionFilter !== null">
            All <span class="font-bold">{{ reactionData?.total ?? 0 }}</span>
          </button>
          <ng-container *ngFor="let r of REACTIONS">
            <button (click)="setReactionFilter(r.type)"
              class="flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors"
              [class.text-[#D31148]]="activeReactionFilter === r.type"
              [class.border-b-2]="activeReactionFilter === r.type"
              [class.border-[#D31148]]="activeReactionFilter === r.type"
              [class.text-gray-500]="activeReactionFilter !== r.type">
              <span style="font-size:18px;line-height:1;">{{ r.emoji }}</span>
              <span>{{ reactionData?.counts?.[r.type] ?? 0 }}</span>
            </button>
          </ng-container>
        </div>
      </div>

      <!-- Reactions List -->
      <div class="flex-1 overflow-y-auto px-4 py-4 bg-white"
        style="scrollbar-width:thin;scrollbar-color:#d1d1d1 #f1f1f1">
        <div *ngIf="reactionsLoading" class="flex items-center justify-center py-12">
          <div class="h-8 w-8 animate-spin rounded-full border-4 border-[#e8e8e8] border-t-[#D31148]"></div>
        </div>

        <div *ngIf="!reactionsLoading" class="space-y-1">
          <div *ngFor="let item of filteredReactions"
            class="flex items-center gap-3 rounded-xl px-2 py-2.5 hover:bg-[#fafafa] transition-colors">
            <div class="relative flex-shrink-0">
              <img
                [src]="item.user?.profileImage?.urlSmall || avatarFallback(item.user?.displayName)"
                class="h-11 w-11 rounded-full object-cover border border-[#f0f0f0]" [alt]="item.user?.displayName" />
              <span
                class="absolute -bottom-0.5 -right-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white text-[11px] shadow-sm"
                [style.background]="getReactionConfig(item.type)?.bg">{{ item.emoji }}</span>
            </div>
            <div class="flex-1 min-w-0">
              <div class="font-semibold text-gray-800 text-sm truncate">{{ item.user?.userName }}</div>
              <div class="text-xs text-gray-400 truncate">{{ item.user?.displayName }}</div>
            </div>
            <div class="flex items-center gap-2 flex-shrink-0">

              <!-- Friend request button -->
              <button (click)="onModalFriendClick(item, $event)" *ngIf="!item.isMe"
                [title]="friendButtonTitle(item.friendship.status ?? 'NONE')"
                [disabled]="item.friendship.status === 'BLOCKED'"
                class="flex items-center justify-center w-8 h-8 rounded-full border transition-colors disabled:opacity-40"
                [ngClass]="item.friendship.status === 'FRIENDS'
                    ? 'border-emerald-500 text-emerald-500 hover:bg-emerald-50'
                    : item.friendship.status === 'PENDING_SENT'
                        ? 'border-orange-400 text-orange-400 hover:bg-orange-50'
                        : 'border-[#D31148] text-[#D31148] hover:bg-[#FFF0F3]'">

                <!-- NONE: add friend -->
                <svg *ngIf="!item.friendship.status || item.friendship.status === 'NONE'" width="15" height="15"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <line x1="19" y1="8" x2="19" y2="14" />
                  <line x1="22" y1="11" x2="16" y2="11" />
                </svg>

                <!-- PENDING_SENT: cancel -->
                <svg *ngIf="item.friendship.status === 'PENDING_SENT'" width="15" height="15" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <line x1="17" y1="8" x2="23" y2="14" />
                  <line x1="23" y1="8" x2="17" y2="14" />
                </svg>

                <!-- PENDING_RECEIVED -->
                <svg *ngIf="item.friendship.status === 'PENDING_RECEIVED'" width="15" height="15" viewBox="0 0 24 24"
                  fill="none" stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <polyline points="16 11 18 13 22 9" />
                </svg>

                <!-- FRIENDS: unfriend -->
                <svg *ngIf="item.friendship.status === 'FRIENDS'" width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <polyline points="16 11 18 13 22 9" />
                </svg>

                <!-- BLOCKED -->
                <svg *ngIf="item.friendship.status === 'BLOCKED'" width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                </svg>

              </button>

              <!-- Follow / Unfollow button -->
              <button (click)="onModalFollowClick(item, $event)" *ngIf="!item.isMe"
                class="flex-shrink-0 px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors" [ngClass]="item.isFollowed
                    ? 'text-gray-700 bg-[#f8f8f8] border border-[#d8d8d8] hover:bg-gray-100'
                    : 'text-green-700 bg-green-100 border border-green-600 hover:bg-green-200'">
                {{ item.isFollowed ? 'Unfollow' : 'Follow' }}
              </button>

            </div>
          </div>
          <div *ngIf="filteredReactions.length === 0"
            class="flex flex-col items-center justify-center py-12 text-gray-400">
            <span style="font-size:40px;">🤷</span>
            <p class="mt-2 text-sm">No reactions yet</p>
          </div>
        </div>
      </div>
    </div>

    <!-- COLLABORATORS VIEW (like comments/reactions) -->
    <div *ngIf="showCollaborators && !showComments && !showReactions && !showTaggedPeople" class="flex-1 flex flex-col overflow-hidden">

      <!-- Image Peek at Top with Opacity -->
      <div *ngIf="post.media.length > 0"
        class="relative bg-gray-900 flex-shrink-0 opacity-50 cursor-pointer overflow-hidden" style="height: 200px;"
        (click)="closeCollaborators()">
        <img [src]="post.media[post.activeSlide].url" [alt]="post.user.name" class="w-full h-full object-cover" />
        <div class="absolute inset-0 bg-black/20"></div>
      </div>

      <div *ngIf="post.media.length === 0 && post.hasBackground"
        class="relative flex-shrink-0 opacity-50 cursor-pointer overflow-hidden" style="height: 200px;"
        [ngClass]="getPatternClass(post.backgroundPattern)" [style.background-color]="post.backgroundBg"
        (click)="closeCollaborators()">
        <div class="absolute inset-0 bg-black/20"></div>
        <div class="absolute inset-0 px-4 py-4 overflow-y-auto custom-scrollbar">
          <p class="text-base font-semibold text-white background-text"
            style="text-shadow: 0 1px 5px rgba(0,0,0,0.3); white-space: pre-wrap; word-wrap: break-word;"
            [innerHTML]="post.description | mentionHighlight" (click)="onMentionClick($event)">
          </p>
        </div>
      </div>

      <!-- Collaborators Header -->
      <div
        class="flex items-center justify-center py-4 bg-white border-b border-gray-100 flex-shrink-0 rounded-t-3xl relative"
        style="margin-top: -57px; z-index: 20;">
        <h3 class="font-bold text-gray-900 text-base">Collaborators</h3>
      </div>

      <!-- Collaborators List -->
      <div class="flex-1 overflow-y-auto px-4 py-4 bg-white"
        style="scrollbar-width:thin;scrollbar-color:#d1d1d1 #f1f1f1">
        <!-- Author -->
        <div class="flex items-center gap-3 p-3 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer"
          [routerLink]="['/profile', post.user?.name, 'post']">
          <img [src]="post.user?.avatar" class="h-11 w-11 rounded-full object-cover border border-[#f0f0f0]"
            [alt]="post.user?.name"
            onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-900 truncate">{{ post.user?.name }}</div>
            <div class="text-xs text-gray-400">Author</div>
          </div>
        </div>

        <!-- Collaborators -->
        <div *ngFor="let collab of post.acceptedCollaborators"
          class="flex items-center gap-3 p-3 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer"
          [routerLink]="['/profile', collab.userName, 'post']">
          <img [src]="collab.profileImage?.urlSmall" [alt]="collab.displayName"
            class="h-11 w-11 rounded-full object-cover border border-[#f0f0f0]"
            onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-900 truncate">@{{ collab.userName }}</div>
            <div class="text-xs text-gray-400 truncate">{{ collab.displayName }}</div>
          </div>
        </div>

        <div *ngIf="(post.acceptedCollaborators?.length ?? 0) === 0"
          class="flex flex-col items-center justify-center py-12 text-gray-400">
          <span style="font-size:40px;">🤷</span>
          <p class="mt-2 text-sm">No collaborators</p>
        </div>
      </div>
    </div>

    <!-- TAGGED PEOPLE VIEW -->
    <div *ngIf="showTaggedPeople && !showComments && !showReactions && !showCollaborators" class="flex-1 flex flex-col overflow-hidden">

      <!-- Image Peek at Top with Opacity -->
      <div *ngIf="post.media.length > 0"
        class="relative bg-gray-900 flex-shrink-0 opacity-50 cursor-pointer overflow-hidden" style="height: 200px;"
        (click)="closeTaggedPeople()">
        <img [src]="post.media[post.activeSlide].url" [alt]="post.user.name" class="w-full h-full object-cover" />
        <div class="absolute inset-0 bg-black/20"></div>
      </div>

      <div *ngIf="post.media.length === 0 && post.hasBackground"
        class="relative flex-shrink-0 opacity-50 cursor-pointer overflow-hidden" style="height: 200px;"
        [ngClass]="getPatternClass(post.backgroundPattern)" [style.background-color]="post.backgroundBg"
        (click)="closeTaggedPeople()">
        <div class="absolute inset-0 bg-black/20"></div>
        <div class="absolute inset-0 px-4 py-4 overflow-y-auto custom-scrollbar">
          <p class="text-base font-semibold text-white background-text"
            style="text-shadow: 0 1px 5px rgba(0,0,0,0.3); white-space: pre-wrap; word-wrap: break-word;"
            [innerHTML]="post.description | mentionHighlight" (click)="onMentionClick($event)">
          </p>
        </div>
      </div>

      <!-- Tagged People Header -->
      <div
        class="flex items-center justify-center py-4 bg-white border-b border-gray-100 flex-shrink-0 rounded-t-3xl relative"
        style="margin-top: -57px; z-index: 20;">
        <h3 class="font-bold text-gray-900 text-base">Tagged People</h3>
      </div>

      <!-- Tagged People List -->
      <div class="flex-1 overflow-y-auto px-4 py-4 bg-white"
        style="scrollbar-width:thin;scrollbar-color:#d1d1d1 #f1f1f1">
        <div *ngFor="let tagged of post.rawMentions"
          class="flex items-center gap-3 p-3 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer"
          [routerLink]="['/profile', tagged.userName, 'post']">
          <img [src]="tagged.profileImage?.urlSmall" [alt]="tagged.displayName"
            class="h-11 w-11 rounded-full object-cover border border-[#f0f0f0]"
            onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-900 truncate">@{{ tagged.userName }}</div>
            <div class="text-xs text-gray-400 truncate">{{ tagged.displayName }}</div>
          </div>
        </div>

        <div *ngIf="(post.rawMentions?.length ?? 0) === 0"
          class="flex flex-col items-center justify-center py-12 text-gray-400">
          <span style="font-size:40px;">🏷️</span>
          <p class="mt-2 text-sm">No tagged people</p>
        </div>
      </div>
    </div>

  </div>
  <app-confirmation-popup [isOpen]="showLoginPrompt" icon="user-add" title="Login Required"
    [message]="'To ' + loginPromptAction" [highlightedName]="loginPromptUserName"
    messageSuffix="you need to be logged in first" confirmLabel="Log In" cancelLabel="Close" (confirmed)="goToLogin()"
    (cancelled)="closeLoginPrompt()">
  </app-confirmation-popup>

  <app-friend-request-limit-popup [isOpen]="showFriendLimitPopup" [hours]="friendLimitHours"
    (closed)="showFriendLimitPopup = false"></app-friend-request-limit-popup>

  <app-confirmation-popup [isOpen]="showUnfriendConfirm" icon="warning" title="Unfriend User"
    message="Are you sure you want to unfriend this user?" confirmLabel="Unfriend" cancelLabel="Cancel"
    (confirmed)="confirmUnfriend()" (cancelled)="cancelUnfriendConfirm()"></app-confirmation-popup>

  <!-- Delete confirmation -->
  <app-confirmation-popup [isOpen]="showDeleteConfirm" icon="warning" title="Delete Post"
    message="Are you sure you want to permanently delete this post? All media will also be removed."
    confirmLabel="Delete" cancelLabel="Cancel" (confirmed)="doDeletePost()" (cancelled)="cancelDelete()">
  </app-confirmation-popup>

  <!-- Leave collaboration confirmation -->
  <app-confirmation-popup [isOpen]="showLeaveConfirm" icon="warning" title="Leave Collaboration"
    message="Are you sure you want to remove yourself from this collaboration?" confirmLabel="Leave"
    cancelLabel="Cancel" (confirmed)="doLeaveCollaboration()" (cancelled)="cancelLeave()">
  </app-confirmation-popup>
</app-modal>

<!-- Report Post -->
<app-report-modal [isOpen]="isReportModalOpen" targetLabel="Post" [isSubmitting]="isSubmittingReport"
  [errorMessage]="reportError" (submitted)="submitPostReport($event)" (cancelled)="closeReportModal()">
</app-report-modal>

<app-confirmation-popup [isOpen]="reportSuccessOpen" icon="info" title="Report Submitted"
  message="Thanks for letting us know. Our team will review it shortly." confirmLabel="" cancelLabel="Close"
  (cancelled)="closeReportSuccess()"></app-confirmation-popup>

<!-- Block User (safeword-confirm) -->
<app-block-user-confirm [isOpen]="showBlockUserConfirm" [targetName]="postAuthorDisplayName"
  (confirmed)="confirmBlockPostUser()" (cancelled)="cancelBlockPostUser()"></app-block-user-confirm>

<!-- Report Comment -->
<app-report-modal [isOpen]="isCommentReportModalOpen" targetLabel="Comment" [isSubmitting]="isSubmittingCommentReport"
  [errorMessage]="commentReportError" (submitted)="submitCommentReport($event)" (cancelled)="closeCommentReportModal()">
</app-report-modal>

<app-confirmation-popup [isOpen]="commentReportSuccessOpen" icon="info" title="Report Submitted"
  message="Thanks for letting us know. Our team will review it shortly." confirmLabel="" cancelLabel="Close"
  (cancelled)="closeCommentReportSuccess()"></app-confirmation-popup>

<style>
  .reaction-picker {
    animation: picker-slide-up 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  @keyframes picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(8px) scale(0.95);
    }

    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  .reaction-emoji-btn {
    animation: emoji-pop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
    opacity: 0;
  }

  @keyframes emoji-pop {
    to {
      opacity: 1;
    }
  }

  .reaction-bounce {
    animation: reaction-bounce 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  @keyframes reaction-bounce {
    0% {
      transform: scale(0);
    }

    50% {
      transform: scale(1.2);
    }

    100% {
      transform: scale(1);
    }
  }

  /* Mention highlighting styles */
  ::ng-deep .mention-highlight {
    color: #2563eb !important;
    font-weight: 700 !important;
  }

  /* Mention editable styles */
  .mention-editable {
    min-height: 20px;
    max-height: 120px;
    overflow-y: auto;
  }

  .mention-editable:empty:before {
    content: attr(data-placeholder);
    color: #9ca3af;
    pointer-events: none;
  }

  .mention-editable:focus:before {
    content: '';
  }

  .mention-editable .mention {
    color: #2563eb;
    font-weight: 700;
    background-color: #eff6ff;
    padding: 0 2px;
    border-radius: 2px;
  }
</style>

<app-share-sheet *ngIf="shareConfig" [config]="shareConfig" [currentCount]="shareCount" (closed)="closeShareSheet()"
  (countUpdated)="onShareCountUpdated($event)">
</app-share-sheet>